export default [
  {
    name: "Dashboard",
    icon: "fas fa-chart-line",
    url: "/dashboard"
  },
  {
    header: true,
    name: "Jobs",
    icon: "flaticon2-architecture-and-city",
    menu: [
      {
        url: "/job/listing",
        name: "Job",
        icon: "flaticon-clipboard"
      },
      {
        url: "/job/create",
        name: "Create Job",
        icon: "flaticon-business"
      },
      {
        url: "/job/dispatch",
        name: "Dispatch",
        icon: "flaticon-list-3"
      },
      {
        url: "/job/search",
        name: "Search",
        icon: "la la-search"
      }
    ]
  }
];
